export const emailRegex = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
export const currencyRegexp = /^[0-9]+(\.([0-9]{1,2})?)?$/;
